import { NOT_LOGGED_IN_USER_ID } from '../constants';
export const isAuthenticatedCustomer = customerId => customerId != null && customerId !== NOT_LOGGED_IN_USER_ID;
//# sourceMappingURL=isAuthenticatedCustomer.js.map